<div
  [loader]="mutationCreateCustomer()?.isLoading"
  class="overflow-y-auto max-h-[75vh] hide-scrollbar md:show-scrollbar"
>
  <div
    class="relative w-[434px] max-w-full h-full px-8 py-6 rounded flex flex-col gap-4"
    [style.backgroundColor]="bgBase()"
  >
    <p class="text-center font-medium text-lg leading-none">
      {{ 'Załóż konto' | translate }}
    </p>

    <p class="text-sm leading-none text-center">
      {{
        'Zaloguj się, aby dokończyć zakup, pobrać bilety i sprawdzić historię zamówień. Nie masz jeszcze konta? Załóż je szybko i wygodnie.'
          | translate
      }}
    </p>

    <form
      [formGroup]="registerFormVM"
      (ngSubmit)="onCreateCustomer()"
      class="flex flex-col gap-3"
      role="form"
    >
      <fieldset class="flex flex-col gap-3">
        <legend class="sr-only">
          {{ 'Dane do rejestracji' | translate }}
        </legend>

        <div class="grid grid-cols-2 gap-3">
          <neopos-input-text
            inputId="input-first-name"
            formControlName="firstName"
            [label]="'Imię *' | translate"
            labelMode="E-COMMERCE"
            padding="medium"
            [autoFocus]="true"
            [errorColor]="accent()"
            [errorAbsolute]="true"
            autocomplete="given-name"
          />

          <neopos-input-text
            inputId="input-last-name"
            formControlName="lastName"
            [label]="'Nazwisko *' | translate"
            labelMode="E-COMMERCE"
            padding="medium"
            [errorColor]="accent()"
            autocomplete="family-name"
          />
        </div>

        <neopos-input-text
          inputId="input-phone"
          formControlName="phone"
          [label]="'Numer telefonu *' | translate"
          labelMode="E-COMMERCE"
          padding="medium"
          [errorColor]="accent()"
          autocomplete="tel"
        />

        <neopos-input-text
          inputId="input-email"
          formControlName="email"
          [label]="'Adres e-mail *' | translate"
          labelMode="E-COMMERCE"
          padding="medium"
          [errorColor]="accent()"
          autocomplete="email"
        />

        <neopos-input-text
          inputId="input-password"
          formControlName="password"
          [label]="'Hasło *' | translate"
          [additionalText]="
            'Twoje hasło powinno mieć co najmniej 8 znaków i zawierać kombinację liter, cyfr oraz znaków specjalnych.'
              | translate
          "
          additionalTextStyle="secondary"
          type="password"
          labelMode="E-COMMERCE"
          padding="medium"
          [errorColor]="accent()"
        />

        <neopos-input-text
          inputId="input-accept-regulations"
          formControlName="repeatPassword"
          [label]="'Powtórz hasło *' | translate"
          type="password"
          labelMode="E-COMMERCE"
          padding="medium"
          [errorColor]="accent()"
        />

        <neopos-input-checkbox
          inputId="input-statute"
          formControlName="statute"
        >
          <span content class="font-normal text-sm leading-none mt-1"
            >{{ '*Akceptuję ' | translate }}
            <a
              (keydown.enter)="onWindowOpen('/regulamin')"
              [routerLink]="['/regulamin' | translate]"
              target="_blank"
              class="underline font-semibold text-[#126BE1]"
              >{{ 'regulamin sklepu' | translate }}</a
            ></span
          >
        </neopos-input-checkbox>
      </fieldset>

      <acc-button
        type="submit"
        [inputId]="'acc-button-register-submit'"
        [attr.ariaLabel]="'Załóż konto' | translate"
      >
        {{ 'Załóż konto' | translate }}
      </acc-button>

      @if (hasFacebook() || hasGoogle()){
      <span class="mx-auto text-sm leading-none">{{ 'lub' | translate }}</span
      >} @if (hasGoogle()){
      <acc-button
        type="button"
        [inputId]="'acc-button-login-google'"
        theme="SOCIAL"
        iconName="google"
        [iconSize]="24"
        (onClick)="onGoogleLogin()"
        [attr.ariaLabel]="'Zaloguj się z Google' | translate"
      >
        {{ 'Zaloguj się z Google' | translate }} </acc-button
      >} @if (hasFacebook()){
      <acc-button
        type="button"
        [inputId]="'acc-button-login-facebook'"
        theme="SOCIAL"
        iconName="facebook"
        [iconSize]="24"
        (onClick)="onFacebookLogin()"
        [attr.ariaLabel]="'Zaloguj się z Facebook' | translate"
      >
        {{ 'Zaloguj się z Facebook' | translate }} </acc-button
      >}
    </form>

    <p class="text-center text-sm leading-none">
      {{ 'Posiadasz już konto?' | translate }}

      <button
        (click)="onOpenLoginModal()"
        class="text-sm leading-none"
        [style.color]="primary()"
      >
        {{ 'Zaloguj się' | translate }}
      </button>
    </p>

    <neopos-icon-button
      name="close"
      [ariaLabel]="'Zamknij' | translate"
      (click)="close()"
      (document:keydown.escape)="close()"
      className="text-[24px]"
      class="absolute top-4 right-4"
    />
  </div>
</div>
